// Small label chip. Tones are soft fills with AA text: brand, rose, amber, emerald, slate, lime, iv, cart, ink, white.
// A square-cornered tag (6 px corners), never a pill. animate="pop" or "drop" plays the entrance once.
import type { ReactNode } from 'react';

export type ChipTone = 'brand' | 'rose' | 'amber' | 'emerald' | 'slate' | 'lime' | 'iv' | 'cart' | 'ink' | 'white';

export function Chip({ children, tone = 'slate', className = '', size = 'md', icon, animate }: {
  children: ReactNode; tone?: ChipTone; className?: string; size?: 'sm' | 'md' | 'lg'; icon?: ReactNode; animate?: 'pop' | 'drop';
}) {
  const anim = animate === 'pop' ? 'rd-pop' : animate === 'drop' ? 'rd-drop-in' : '';
  return (
    <span data-tone={tone} data-size={size} className={`rd-chip ${anim} ${className}`}>
      {icon && <span aria-hidden="true" className="inline-flex shrink-0">{icon}</span>}
      {children}
    </span>
  );
}
